import {Paragraph} from './Paragraph';
import {createDefaultContent} from './utils';

export default Paragraph;

export {
  createDefaultContent as createParagraphContent,
}
